import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateOrUpdateDocumentTypeRequest, CreateOrUpdateDocumentTypeResponse } from '../interfaces/create-update-document-type.interface';
import { Observable } from 'rxjs';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';
import { environment } from 'src/environments/enviroments';
import { DocumentTypeDTO } from '../../dashboards/files-clients/interface/company-document.interface';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {

  constructor(private httpClient: HttpClient) { }

  getDocumentTypeById(documentTypeId: number): Observable<DocumentTypeDTO> {
    const endpoint = `${environment.apiUrl}/DocumentTypes/${documentTypeId}`;
    return this.httpClient.get<DocumentTypeDTO>(endpoint);
  }

  createDocumentType(request: CreateOrUpdateDocumentTypeRequest): Observable<ActionResponseDTO<CreateOrUpdateDocumentTypeResponse>> {
    const endpoint = `${environment.apiUrl}/DocumentTypes`;
    return this.httpClient.post<ActionResponseDTO<CreateOrUpdateDocumentTypeResponse>>(endpoint, request);
  }

  updateCompanyDocumentType(documentTypeId: number, request: CreateOrUpdateDocumentTypeRequest): Observable<ActionResponseDTO<CreateOrUpdateDocumentTypeResponse>> {
    const endpoint = `${environment.apiUrl}/DocumentTypes/${documentTypeId}`;
    return this.httpClient.put<ActionResponseDTO<CreateOrUpdateDocumentTypeResponse>>(endpoint, request);
  }
}


